module.exports = __webpack_public_path__ + "static/media/shareInviteMailIcon.4bb776f8.png";